/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    let blocks: Array<CodeBlock> = [];
    const { project } = feature;
    const MQTT_INTERFACE = 'current_interface';
    if (feature.getSettingValue('ENABLED').toString() === '0') {
        return blocks;
    }
    const MQTT_NAME = feature.getSettingValue('MQTT_NAME');
    const MQTT_PASSWORD = feature.getSettingValue('MQTT_PASSWORD');
    const MQTT_APP_CLIENT_ID = feature.getSettingValue('MQTT_APP_CLIENT_ID');
    const MQTT_SERVER_HOST = feature.getSettingValue('MQTT_SERVER_HOST');
    const MQTT_DESTINATION_PORT = feature.getSettingValue('MQTT_DESTINATION_PORT', true);
    const CERTIFICATEFILE = feature.getSettingValue('CERTIFICATEFILE');
    const MQTT_TLS = feature.getSettingValue('MQTT_TLS');
    const TOPICS = feature.getSettingValue('TOPICS');
    let caDataCode = '';

    blocks.push({
        location: 'IMPORTS',
        blockType: BlockType.CODE,
        template: 'from async_mqtt import mqttHandler',
    });

    if (CERTIFICATEFILE !== '' && MQTT_TLS === '1') {
        const filepath = CERTIFICATEFILE.split('\n')[0];
        caDataCode = `
with open('${filepath}', 'rb') as f:
    cadata = f.read()`;
    }

    blocks.push({
        location: 'callback_mqtt_connect_ok',
        blockType: BlockType.CODE,
        template: 'global MQTTClientInstance',
    });


    for (let i = 0; i < TOPICS.length; i++) {
        const topic = TOPICS[i];
        blocks = blocks.concat(topic.getCodeBlocks());
    }

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: 'MQTTClientInstance = None',
    });


    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.LOCATION,
        id: 'callback_mqtt_notif',
        template: `

def mqtt_topic_match(subscribed_topic, current_topic):
    if subscribed_topic == current_topic:
        return True
    topic_parts = subscribed_topic.split('/')
    current_topic_parts = current_topic.split('/')
    if len(topic_parts) > len(current_topic_parts):
        return False
    for i in range(len(topic_parts)):
        if topic_parts[i] == '#':
            return True
        if topic_parts[i] != '+' and topic_parts[i] != current_topic_parts[i]:
            return False
    return True

def callback_mqtt_notif(topic, data):
    #****callback_mqtt_notif****#
    pass`,
    });

    blocks.push({
        location: project.getNetworkConnectedLocation(MQTT_INTERFACE),
        blockType: BlockType.CODE,
        template: `
${caDataCode}
global MQTTClientInstance 
MQTTClientInstance = mqttHandler(
    client_id=${MQTT_APP_CLIENT_ID},
    server=${MQTT_SERVER_HOST},
    port=${MQTT_DESTINATION_PORT},
    deviceId=${MQTT_NAME},
    devicePassword=${MQTT_PASSWORD},
    sub_callback=callback_mqtt_notif,
    tls=${MQTT_TLS === '1' ? 'True' : 'False'},
    cadata=${caDataCode ? 'cadata' : 'None'})
MQTTClientInstance.set_on_connect(callback_mqtt_connect_ok)
MQTTClientInstance.connect()`,
    });

    return blocks;
};
